import {
    people_types,
    doc_types,
    add_references_columns,
    languages,
    enw_types,
    ris_types,
    titles,
    dates
} from './model'
import htmlDocx from 'html-docx-js/dist/html-docx'

// Not tested

export function addIso690(docs) {
    let people_type_list = Object.keys(people_types)
    for (let i in docs) {
        let list = Object.keys(docs[i]).filter(v => people_type_list.includes(v))
        if (!!list.length) {
            for (let j = 0; j < list.length; j++) {
                let authors_name = []
                let authors = docs[i][list[j]]
                if (!!authors.length) {
                    for (let k = 0; k < authors.length; k++) {
                        let firstname = authors[k].firstname
                        let lastname = authors[k].lastname
                        let iso690 = authors[k].iso690
                        let author_name = ''
                        if (!!iso690) {
                            author_name = iso690
                        } else if (lastname == null || lastname == '') {
                            author_name = 'N.R.'
                        } else if (firstname == null || firstname == '') {
                            author_name = lastname.toUpperCase()
                        } else {
                            author_name = lastname.toUpperCase() + ', ' + firstname
                        }
                        docs[i][list[j]][k].iso690 = author_name
                        authors_name.push(author_name)
                    }
                    docs[i][list[j] + '_iso690'] = authors_name.join(' ; ')
                }
            }
        }
    }
    return Promise.resolve(docs)
}

export function toDatetimeLocal(date) {
    let ten = function(i) {
        return (i < 10 ? '0' : '') + i
    }
    let YYYY = date.getFullYear()
    let MM = ten(date.getMonth() + 1)
    let DD = ten(date.getDate())
    let HH = ten(date.getHours())
    let II = ten(date.getMinutes())
    let SS = ten(date.getSeconds())
    return YYYY + '-' + MM + '-' + DD + 'T' + HH + ':' + II + ':' + SS
}

export function sortProjects(input_projects, key) {
    let projs = JSON.parse(JSON.stringify(input_projects))
    return projs.sort(function(a, b) {
        switch (key) {
            case 0:
                // Recently visited
                if (a.last_visit_ts < b.last_visit_ts)
                    return 1;
                if (a.last_visit_ts > b.last_visit_ts)
                    return -1;
                return 0;
                break;
                break;
            case 1:
                // Title (ascending)
                if (a.title < b.title)
                    return -1;
                if (a.title > b.title)
                    return 1;
                return 0;
                break;

            case 2:
                // Title (descending)
                if (a.title > b.title)
                    return -1;
                if (a.title < b.title)
                    return 1;
                return 0;
                break;

            case 3:
                // Created (oldest first)
                if (!!a.created_ts) {
                    if (a.created_ts < b.created_ts)
                        return -1;
                    if (a.created_ts > b.created_ts)
                        return 1;
                } else {
                    if (a.created_ts < b.created_ts)
                        return -1;
                    if (a.created_ts > b.created_ts)
                        return 1;
                }
                return 0;
                break;

            case 4:
                // Created (newest first)
                if (!!a.date) {
                    if (a.created_ts > b.created_ts)
                        return -1;
                    if (a.created_ts < b.created_ts)
                        return 1;
                } else {
                    if (a.created_ts > b.created_ts)
                        return -1;
                    if (a.created_ts < b.created_ts)
                        return 1;
                }
                return 0;
                break;
        }
    })
}

export function getDDay(date) {
    // date format: YYYY-MM-DD
    let one_day = 24 * 60 * 60 * 1000
    let first_date = (new Date(date)).setHours(24, 0, 0, 0)
    let now_date = new Date()

    return Math.round(Math.abs((first_date - now_date) / one_day))
}

export function returnDocObj(type) {
    switch (type) {
        case 0:
            return {
                doc_type: 0,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                book_title: "",
                lang: "xx",
                contents: "",
                keywords: "",
                DOI: "",
                URL: "",
                volume: "",
                edition: "",
                publisher: "",
                OCLC: "",
                ISBN: "",
                editors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                editor_c: true,
                translators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                translator_c: true,
                paper_ebook: "",
            }
            break;
        case 1:
            return {
                doc_type: 1,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                title: "",
                lang: "xx",
                contents: "",
                keywords: "",
                DOI: "",
                URL: "",
                diplome_title: "",
                university: "",
                OCLC: "",
                juries: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                jury_c: true,
                translators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                translator_c: true,
                department: "",
            }
            break;
        case 2:
            return {
                doc_type: 2,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                document_title: "",
                lang: "xx",
                contents: "",
                keywords: "",
                DOI: "",
                URL: "",
                number: "",
                document_category: "",
                institution: "",
                OCLC: "",
                ISBN: "",
                editors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                editor_c: true,
                translators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                translator_c: true,
                department: "",
            }
            break;
        case 3:
            return {
                doc_type: 3,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                date: "",
                law_title: "",
                lang: "xx",
                contents: "",
                URL: "",
                number: "",
                version: "",
                institution: "",
                OCLC: "",
                translators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                translator_c: true,
                law_category: "",
            }
            break;
        case 4:
            return {
                doc_type: 4,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                date: "",
                statistics_title: "",
                lang: "xx",
                description: "",
                URL: "",
                number: "",
                provisional_confirmed: "",
                institution: "",
                OCLC: "",
                paper_online: "",
            }
            break;
        case 5:
            return {
                doc_type: 5,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                issue_title: "",
                lang: "xx",
                contents: "",
                URL: "",
                journal_name: "",
                volume: "",
                institution: "",
                ISSN: "",
                editors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                editor_c: true,
                paper_online: "",
            }
            break;
        case 6:
            return {
                doc_type: 6,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                issue_title: "",
                lang: "xx",
                contents: "",
                DOI: "",
                URL: "",
                conference_name: "",
                numberth: "",
                session: "",
                institution: "",
                OCLC: "",
                ISBN: "",
                editors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                editor_c: true,
                place: "",
            }
            break;
        case 7:
            return {
                doc_type: 7,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                article_title: "",
                lang: "xx",
                description: "",
                DOI: "",
                URL: "",
                newspaper_name: "",
                number: "",
                morning_afternoon: "",
                company: "",
                OCLC: "",
                ISSN: "",
                paper_online: "",
            }
            break;
        case 8:
            return {
                doc_type: 8,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                issue_title: "",
                lang: "xx",
                contents: "",
                URL: "",
                magazine_name: "",
                number: "",
                publisher: "",
                ISBN: "",
                ISSN: "",
                editors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                editor_c: true,
                paper_online: "",
            }
            break;
        case 9:
            return {
                doc_type: 9,
                creators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                creator_c: true,
                date: "",
                album_name: "",
                lang: "xx",
                contents: "",
                URL: "",
                label: "",
                dvd_online: "",
            }
            break;
        case 10:
            return {
                doc_type: 10,
                directors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                director_c: true,
                date: "",
                film_title: "",
                lang: "xx",
                description: "",
                URL: "",
                production: "",
                translators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                translator_c: true,
                note: "",
            }
            break;
        case 100:
            return {
                doc_type: 100,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                chapter_title: "",
                lang: "xx",
                description: "",
                keywords: "",
                DOI_chapter: "",
                URL_chapter: "",
                book_title: "",
                volume: "",
                pages: "",
                edition: "",
                publisher: "",
                DOI_book: "",
                OCLC: "",
                ISBN: "",
                URL_book: "",
                editors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                editor_c: true,
                translators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                translator_c: true,
                publishing_date: "",
                other_idf: "",
                paper_ebook: "",
            }
            break;
        case 101:
            return {
                doc_type: 101,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                chapter_title: "",
                lang: "xx",
                description: "",
                keywords: "",
                DOI_chapter: "",
                URL_chapter: "",
                title: "",
                pages: "",
                diplome_title: "",
                university: "",
                DOI_thesis: "",
                OCLC: "",
                URL_thesis: "",
                juries: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                jury_c: true,
                publishing_date: "",
                other_idf: "",
                department: "",
            }
            break;
        case 102:
            return {
                doc_type: 102,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                article_title: "",
                lang: "xx",
                description: "",
                keywords: "",
                DOI_article: "",
                URL_article: "",
                document_title: "",
                number: "",
                pages: "",
                document_category: "",
                institution: "",
                DOI_document: "",
                OCLC: "",
                ISBN: "",
                URL_report: "",
                editors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                editor_c: true,
                publishing_date: "",
                other_idf: "",
                department: "",
            }
            break;
        case 103:
            return {
                doc_type: 103,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                date: "",
                article_title: "",
                lang: "xx",
                description: "",
                URL_article: "",
                law_title: "",
                number: "",
                article_number: "",
                version: "",
                institution: "",
                OCLC: "",
                URL_law: "",
                other_idf: "",
                law_category: "",
            }
        case 104:
            return {
                doc_type: 104,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                statistics_date: "",
                table_title: "",
                lang: "xx",
                description: "",
                URL_table: "",
                statistics_title: "",
                number: "",
                provisional_confirmed: "",
                institution: "",
                OCLC: "",
                URL_statistics: "",
                publishing_date: "",
                other_idf: "",
                paper_online: "",
            }
            break;
        case 105:
            return {
                doc_type: 105,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                article_title: "",
                journal_name: "",
                volume: "",
                pages: "",
                DOI_article: "",
                lang: "xx",

                abstract: "",
                keywords: "",
                editors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                editor_c: true,
                translators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                translator_c: true,
                institution: "",
                ISSN: "",
                URL_article: "",
                URL_journal: "",
                paper_online: "",
                other_idf: "",
            }
            break;
        case 106:
            return {
                doc_type: 106,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                address_date: "",
                article_title: "",
                lang: "xx",
                abstract: "",
                keywords: "",
                DOI_paper: "",
                URL_article: "",
                conference_name: "",
                numberth: "",
                pages: "",
                session: "",
                institution: "",
                DOI_proceeding: "",
                OCLC: "",
                ISBN: "",
                URL_conference: "",
                editors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                editor_c: true,
                translators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                translator_c: true,
                conference_dates: "",
                other_idf: "",
                place: "",
            }
            break;
        case 107:
            return {
                doc_type: 107,
                reporters: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                article_title: "",
                lang: "xx",
                description: "",
                DOI: "",
                URL_article: "",
                newspaper_name: "",
                number: "",
                pages: "",
                morning_afternoon: "",
                company: "",
                OCLC: "",
                ISSN: "",
                URL_newspaper: "",
                translators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                translator_c: true,
                other_idf: "",
                paper_online: "",
            }
            break;
        case 108:
            return {
                doc_type: 108,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                article_title: "",
                lang: "xx",
                description: "",
                keywords: "",
                DOI_article: "",
                URL_article: "",
                magazine_name: "",
                number: "",
                pages: "",
                publisher: "",
                ISBN: "",
                ISSN: "",
                URL_magazine: "",
                editors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                editor_c: true,
                translators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                translator_c: true,
                other_idf: "",
                paper_online: "",
            }
            break;
        case 109:
            return {
                doc_type: 109,
                creators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                creator_c: true,
                date: "",
                music_title: "",
                lang: "xx",
                description: "",
                URL_music: "",
                album_name: "",
                label: "",
                URL_album: "",
                other_idf: "",
                dvd_online: "",
            }
            break;
        case 110:
            return {
                doc_type: 110,
                directors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                director_c: true,
                date: "",
                episode_title: "",
                lang: "xx",
                description: "",
                URL_episode: "",
                film_title: "",
                episode_number: "",
                production: "",
                URL_film: "",
                translators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                translator_c: true,
                year: "",
                other_idf: "",
                note: "",
            }
            break;
        case 901:
            return {
                doc_type: 901,
                makers: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                maker_c: true,
                date: "",
                sub_title: "",
                lang: "xx",
                description: "",
                DOI: "",
                URL_map: "",
                map_title: "",
                map_size: "",
                publisher: "",
                URL_publisher: "",
                other_idf: "",
                paper_digital: "",
            }
            break;
        default:
            return {
                doc_type: 999,
                authors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                author_c: true,
                date: "",
                sub_title: "",
                lang: "xx",
                description: "",
                keywords: "",
                DOI: "",
                URL: "",
                publication_title: "",
                number: "",
                pages: "",
                edition: "",
                publisher: "",
                DOI_publication: "",
                OCLC: "",
                ISBN: "",
                URL_publication: "",
                editors: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                editor_c: true,
                translators: [{
                    ordinal_num: 1,
                    lastname: "",
                    firstname: "",
                }],
                translator_c: true,
                publishing_date: "",
                other_idf: "",
                note: "",
            }
    }
}

export function returnDocMain(type) {
    switch (type) {
        case 0:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'book_title',
                'lang', 'publisher', 'editors', 'editor_c', 'ISBN',
                'translators', 'translator_c',
            ]
            break;
        case 1:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'title', 'lang',
                'diplome_title', 'university', 'department',
                'translators', 'translator_c',
            ]
            break;
        case 2:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'document_title',
                'lang', 'number', 'document_category', 'institution',
                'translators', 'translator_c',
            ]
            break;
        case 3:
            return [
                'doc_type', 'authors', 'date', 'law_title', 'lang',
                'number', 'version', 'institution', 'law_category',
                'translators', 'translator_c',
            ]
            break;
        case 4:
            return [
                'doc_type', 'authors', 'date', 'statistics_title', 'lang',
                'number', 'institution', 'translators', 'translator_c',
            ]
            break;
        case 5:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'issue_title',
                'lang', 'journal_name', 'volume', 'institution', 'ISSN',
                'translators', 'translator_c',
            ]
            break;
        case 6:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'issue_title',
                'lang', 'conference_name', 'numberth', 'institution', 'place',
            ]
            break;
        case 7:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'article_title',
                'lang', 'newspaper_name', 'number', 'translators', 'translator_c',
            ]
            break;
        case 8:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'issue_title',
                'lang', 'magazine_name', 'number', 'translators', 'translator_c',
            ]
            break;
        case 9:
            return [
                'doc_type', 'creators', 'creator_c', 'date', 'album_name',
                'lang', 'label', 'translators', 'translator_c',
            ]
            break;
        case 10:
            return [
                'doc_type', 'directors', 'director_c', 'date', 'film_title',
                'lang', 'production', 'translators', 'translator_c',
            ]
            break;
        case 100:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'chapter_title',
                'lang', 'book_title', 'pages', 'publisher', 'editors', 'editor_c',
                'translators', 'translator_c',
            ]
            break;
        case 101:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'chapter_title',
                'lang', 'title', 'pages', 'diplome_title', 'university', 'department',
                'translators', 'translator_c',
            ]
            break;
        case 102:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'article_title',
                'lang', 'document_title', 'number', 'pages', 'institution',
                'translators', 'translator_c',
            ]
            break;
        case 103:
            return [
                'doc_type', 'authors', 'date', 'article_title', 'lang',
                'law_title', 'number', 'article_number', 'version', 'institution',
                'translators', 'translator_c',
            ]
            break;
        case 104:
            return [
                'doc_type', 'authors', 'statistics_date', 'table_title', 'lang',
                'statistics_title', 'number', 'institution',
                'translators', 'translator_c',
            ]
            break;
        case 105:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'article_title',
                'lang', 'DOI_article', 'journal_name', 'volume', 'pages',
                'translators', 'translator_c',
            ]
            break;
        case 106:
            return [
                'doc_type', 'authors', 'author_c', 'address_date',
                'article_title', 'lang', 'conference_name', 'numberth',
                'pages', 'session', 'institution', 'place',
                'translators', 'translator_c',
            ]
            break;
        case 107:
            return [
                'doc_type', 'reporters', 'author_c', 'date', 'article_title',
                'lang', 'newspaper_name', 'number', 'pages', 'morning_afternoon',
                'translators', 'translator_c',
            ]
            break;
        case 108:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'article_title',
                'lang', 'magazine_name', 'number', 'pages',
                'translators', 'translator_c',
            ]
            break;
        case 109:
            return [
                'doc_type', 'creators', 'creator_c', 'date', 'music_title',
                'lang', 'album_name', 'label', 'translators', 'translator_c',
            ]
            break;
        case 110:
            return [
                'doc_type', 'directors', 'director_c', 'date', 'episode_title',
                'lang', 'film_title', 'episode_number', 'production',
                'translators', 'translator_c',
            ]
            break;
        case 901:
            return [
                'doc_type', 'makers', 'maker_c', 'date', 'sub_title',
                'lang', 'map_title', 'map_size', 'publisher',
                'translators', 'translator_c',
            ]
            break;
        case 999:
            return [
                'doc_type', 'authors', 'author_c', 'date', 'sub_title',
                'lang', 'publication_title', 'translators', 'translator_c',
            ]
            break;
    }
}

export function deleteEmptyFields(doc) {
    Object.keys(doc).forEach(function(key) {
        let value = doc[key]
            // Delete empty people fields
        if (Object.keys(people_types).includes(key)) {
            let complete_key = people_types[key].complete
            if (Array.isArray(value)) {
                let arr = value.filter(i => !!i.lastname || !!i.name_id)
                if (!!arr.length) {
                    doc[key] = arr
                } else {
                    delete doc[key]
                    delete doc[complete_key]
                }
            } else {
                delete doc[key]
                delete doc[complete_key]
            }
        }
        // Delete empty fields
        else {
            if ((value === null) ||
                (Array.isArray(value) && !value.length) ||
                (!Array.isArray(value) && value === "")) {
                delete doc[key]
            }
        }
    })
    return doc
}

export function returnDocInput(type) {
    switch (type) {
        case 0:
            return {
                title: 'book_title',
                year: 'date',
                authors: 'authors',
            }
            break;
        case 1:
            return {
                title: 'title',
                year: 'date',
                authors: 'authors',
            }
            break;
        case 2:
            return {
                title: 'document_title',
                year: 'date',
                authors: 'authors',
            }
            break;
        case 3:
            return {
                title: 'law_title',
                year: 'date',
                authors: 'authors',
            }
            break;
        case 4:
            return {
                title: 'statistics_title',
                year: 'date',
                authors: 'authors',
            }
            break;
        case 5:
        case 6:
        case 8:
            return {
                title: 'issue_title',
                year: 'date',
                authors: 'authors',
            }
            break;
        case 6:
            return {
                title: 'issue_title',
                year: 'date',
                authors: 'authors',
            }
            break;
        case 7:
            return {
                title: 'article_title',
                year: 'date',
                authors: 'authors',
            }
            break;
        case 9:
            return {
                title: 'album_name',
                year: 'date',
                authors: 'creators',
            }
            break;
        case 10:
            return {
                title: 'film_title',
                year: 'date',
                authors: 'directors',
            }
            break;
        case 100:
        case 101:
            return {
                title: 'chapter_title',
                year: 'date',
                authors: 'authors',
            }
            break;
        case 102:
        case 103:
        case 105:
        case 108:
            return {
                title: 'article_title',
                year: 'date',
                authors: 'authors',
            }
            break;
        case 104:
            return {
                title: 'table_title',
                year: 'statistics_date',
                authors: 'authors',
            }
            break;
        case 106:
            return {
                title: 'article_title',
                year: 'address_date',
                authors: 'authors',
            }
            break;
        case 107:
            return {
                title: 'article_title',
                year: 'date',
                authors: 'reporters',
            }
            break;
        case 109:
            return {
                title: 'music_title',
                year: 'date',
                authors: 'creators',
            }
            break;
        case 110:
            return {
                title: 'episode_title',
                year: 'date',
                authors: 'directors',
            }
            break;
        case 901:
            return {
                title: 'sub_title',
                year: 'date',
                authors: 'makers',
            }
            break;
        case 999:
            return {
                title: 'sub_title',
                year: 'date',
                authors: 'authors',
            }
            break;
    }
}

export function createDocsArray(docs) {
    let docs_array = []
    let src_number = 1
    if (!!docs.length) {
        for (let i = 0; i < docs.length; i++) {
            let check_doc = JSON.parse(JSON.stringify(docs[i]))
            check_doc = changeValueForDB(deleteEmptyFields(check_doc))
            let doc = {
                source: { src_number },
                document: check_doc,
            }
            src_number += 1
            docs_array.push(doc)
        }
    }
    // console.log('docs_array', docs_array)
    return docs_array
}

export function isNumeric(value) {
    return /^-{0,1}\d+$/.test(value)
}

export function changeDOIFormat(value) {
    //doi display guideline 2017
    // https://doi.org/10.1037/arc0000014
    let doi_http = [
        'https://dx.doi.org/', 'https://doi.org/',
        'Retrieved from https://dx.doi.org/',
        'doi:https://dx.doi.org/',
        'https://doi:', 'http://dx.doi.org',
    ]
    let doi_general = ['doi:', 'doi.', 'Doi:', 'DOI:']

    let doi = null
    let doi_url = null

    // console.log('value', value)

    var http_form = doi_http.filter(v => value.includes(v))[0]
    var general_form = doi_general.filter(v => value.includes(v))[0]

    // console.log('http', http_form, general_form)

    if (!!http_form) { doi = value.replace(http_form, '') } else if (!!general_form) { doi = value.replace(general_form, '') } else if (isNumeric(value.charAt(0))) { doi = value }

    if (!doi) {
        doi = doi_url = value
    } else {
        doi = doi.trim()
        doi_url = 'https://doi.org/' + doi
    }

    // console.log('doi function', doi, doi_url)

    return { doi, doi_url }
}

export function changeValueForDB(doc) {
    let keys = Object.keys(doc)
    let required_fields = doc_types[doc.doc_type].required_fields
    let people_fields = Object.keys(people_types)
    let DOIs = ['DOI', 'DOI_chapter', 'DOI_article', 'DOI_paper']

    // Fill required field
    let title = required_fields.find(v => titles.includes(v))
    let author = required_fields.find(v => people_fields.includes(v))
    let author_c = people_types[author].complete
    let date = required_fields.find(v => dates.includes(v))
    if (!keys.includes(title)) {
        doc[title] = 'n.r.'
    }
    if (!keys.includes(author)) {
        doc[author] = [{ name_id: 1, ordinal_num: 1 }]
        doc[author_c] = true
    }
    if (!keys.includes(date)) {
        doc[date] = "--"
    }
    if (!keys.includes('lang')) {
        doc['lang'] = "xx"
    }

    // Revise the form
    Object.keys(doc).forEach(function(key) {
        // authors
        if (people_fields.includes(key)) {
            for (let i = 0; i < doc[key].length; i++) {
                doc[key][i]['ordinal_num'] = i + 1
                if (!!doc[key][i]['name_id']) {
                    delete doc[key][i]['lastname']
                    delete doc[key][i]['firstname']
                }
            }
        }
        // dates
        if (dates.includes(key)) {
            doc[key] = doc[key].toString().replace('///', '').trim()
        }
        // DOI
        if (DOIs.includes(key)) {
            let doi_text = doc[key]
            doc[key] = changeDOIFormat(doi_text)['doi_url']
        }

        // ISSN
        if (key == 'issn') {
            var issn = doc[key]
            var converted_issn = ''

            //check ';', ','
            let n_semicolon = issn.split(';').length - 1
            let n_comma = issn.split(',').length - 1

            if (n_semicolon * n_comma == 0) {

                //step 1 split
                issn = issn.replace(',', ';')
                let issn_array = issn.split(';')

                //step 2 detect case
                for (let i = 0; i < issn_array.length; i++) {
                    let unit_new
                    let unit = issn_array[i].trim()
                    unit = unit.split('-').join('')

                    let n_digit = unit.length

                    switch (n_digit) {
                        //issn
                        case 8:
                            let issn_0 = unit.substring(0, 4)
                            let issn_1 = unit.substring(4, 8)
                            unit_new = issn_0.concat('-', issn_1.toLowerCase())
                            break;

                            //isbn 10
                        case 10:
                            unit_new = unit.toLowerCase()
                            break;

                            //isbn 13
                        case 13:
                            let i13_pre = unit.substring(0, 3)
                            let i13_body = unit.substring(3, 13).toLowerCase()
                            unit_new = i13_pre.concat('-', i13_body)
                            break;

                        default:
                            unit_new = unit
                            break;
                    } //switch end

                    if (!!converted_issn.length) {
                        converted_issn = converted_issn.concat(';', unit_new)
                    } else {
                        converted_issn = unit_new
                    }
                } // for end
                doc[key] = converted_issn
            }
        }
    })
    return doc
}

export function checkInputForm(text) {
    let sentence = (text.split('\n')[0]).trim()
    let word = sentence.split(' ')[0]
    if (sentence.match(/^%\S\s/g)) {
        return 'enw'
    } else if (sentence.match(/^\S\S\s/g)) {
        return 'ris'
    } else if (sentence.match(/^@\S[A-Za-z]+{/g)) {
        return 'bib'
    }
    return null
}

export function convertEnwToBT(type, keys, values) {
    let doc = {}
    let enw_model, tags

    let doc_type_keys = Object.keys(doc_types)
    let doc_type_values = Object.values(doc_types)

    let type_id = 999
    let type_index = doc_type_values
        .findIndex(el => el.keyname == type)
    if (type_index > -1) {
        type_id = parseInt(doc_type_keys[type_index])
    }

    enw_model = returnEnwModel(type_id)
    tags = Object.keys(enw_model)
        // console.log('tags', tags)

    doc['doc_type'] = type_id

    // Exception: titles of parts
    if (type_id >= 100 && type_id < 200) {
        let changing_tag = type_id == 105 ? '%J' : '%B'
        let titles = keys.filter(v => v == changing_tag)
        let sub_titles = keys.filter(v => v == '%T')
        if (!titles.length) {
            if (sub_titles.length == 1) {
                let index_T = keys.indexOf('%T')
                keys.push(changing_tag)
                values.push(values[index_T])
            } else if (sub_titles.length > 1) {
                let indice_T = []
                for (let i = 0; i < keys.length; i++) {
                    if (keys[i] == '%T') {
                        indice_T.push(i)
                    }
                }
                keys[indice_T[1]] = changing_tag
            }
        }
    }

    for (let i = 0; i < keys.length; i++) {
        let key, bt_key, value
        key = keys[i]
        value = values[i]

        if (tags.includes(key)) {

            bt_key = enw_model[key]
                // console.log(key, value, bt_key)

            // People
            let people_type_list = Object.keys(people_types)
            if (people_type_list.includes(bt_key)) {
                let lastname = value.split(',')[0].trim()
                let firstname = value.split(',').length > 1 ? value.split(',')[1].trim() : ""
                if (doc[bt_key]) {
                    let num = doc[bt_key].length + 1
                    doc[bt_key].push({
                        lastname,
                        firstname,
                        ordinal_num: num
                    })
                } else {
                    doc[bt_key] = [{ lastname, firstname, ordinal_num: 1 }]
                }
            }

            // Keywords
            else if (bt_key == 'keywords') {
                if (doc[bt_key]) {
                    doc[bt_key] += ";" + value
                } else {
                    doc[bt_key] = value
                }
            }

            //languages
            else if (bt_key == 'lang') {
                for (let lnkey in languages) {
                    let names = languages[lnkey].names
                    let value_lc = value.toLowerCase()
                    if (names.includes(value_lc)) {
                        doc[bt_key] = lnkey
                    }
                }
                if (!doc[bt_key]) {
                    doc[bt_key] = 'xx'
                }
            }

            // Issue
            else if (bt_key == 'issue') {
                // console.log('issue', bt_key)
                if (!doc['volume']) {
                    doc['volume'] = "(" + value + ")"
                } else {
                    doc['volume'] += "(" + value + ")"
                }
                // console.log('volume', doc['volume'])
            } else if (bt_key == 'volume') {
                if (!!doc[bt_key]) {
                    doc[bt_key] = value + doc[bt_key]
                } else {
                    doc[bt_key] = value
                }
            } else { doc[bt_key] = value }
        }
    }

    // Revise the form
    let result_doc = returnDocObj(doc['doc_type'])
    Object.keys(result_doc).forEach(function(key) {
        if (key in doc) {
            result_doc[key] = doc[key]
        }
    })
    return result_doc
}

export function convertRisToBT(type, keys, values) {
    let doc = {}
    let ris_model, tags

    let doc_type_keys = Object.keys(doc_types)
    let doc_type_values = Object.values(doc_types)

    let type_id = 999
    let type_index = doc_type_values
        .findIndex(el => el.keyname == type)
    if (type_index > -1) {
        type_id = parseInt(doc_type_keys[type_index])
    }

    ris_model = returnRisModel(type_id)
    tags = Object.keys(ris_model)

    doc['doc_type'] = type_id

    // Concate T1 and TI
    if (keys.includes('T1') && keys.includes('TI')) {
        let index_TI = keys.indexOf('TI')
        let index_T1 = keys.indexOf('T1')
        values[index_TI] = values[index_TI] + " " + values[index_T1] + '123'
        keys.splice(index_T1, 1)
        values.splice(index_T1, 1)
    }

    for (let i = 0; i < keys.length; i++) {
        let key, bt_key, value
        key = keys[i]
        value = values[i]

        // Exception: JO
        if (key == 'JO') {
            if (value == 'null' || !value) {
                if (!!keys.includes('JF')) {
                    var index_JF = keys.indexOf('JF')
                    var is_exist = !!values[index_JF] && values[index_JF] != 'null'
                    if (is_exist) { value = values[index_JF] }
                } else if (!!keys.includes('JA')) {
                    var index_JA = keys.indexOf('JA')
                    var is_exist = !!values[index_JA] && values[index_JA] != 'null'
                    if (is_exist) { value = values[index_JA] }
                } else if (!!keys.includes('T2')) {
                    var index_T2 = keys.indexOf('T2')
                    var is_exist = !!values[index_T2] && values[index_T2] != 'null'
                    if (is_exist) { value = values[index_T2] }
                } else {
                    value = 'n.r.'
                }
            }
        }

        // Exception: JF or JA or T2
        if (key == 'JF' || key == 'JA' || key == 'T2') {
            if (!keys.includes('JO')) {
                doc[ris_model['JO']] = value
            }
        }
        // Exception: RI
        if (key == 'RI' || key == 'R1') {
            if (!keys.includes('TI') && !keys.includes('T1')) {
                doc[ris_model['TI']] = value
            } else {
                let index_TI = keys.indexOf('TI')
                let index_T1 = keys.indexOf('T1')
                let is_exist = !!values[index_TI] || !!values[index_T1]
                if (!is_exist) { doc[ris_model['TI']] = value }
            }
        }
        // Exception: A1 or A2
        if (key == 'A1' || key == 'A2') {
            key = 'AU'
        }
        // Exeption: N2
        if (key == 'N2') {
            if (!keys.includes('AB')) {
                doc[ris_model['AB']] = value
            } else {
                let index_AB = keys.indexOf('AB')
                let is_exist = !!values[index_AB]
                if (!is_exist) { doc[ris_model['AB']] = value }
            }
        }
        // Exception: U2
        if (key == 'U2') {
            if (!keys.includes('DO')) {
                doc[ris_model['DO']] = value
            } else {
                let index_DO = keys.indexOf('DO')
                let is_exist = !!values[index_DO]
                if (!is_exist) { doc[ris_model['DO']] = value }
            }
        }
        // Exception: Y1
        if (key == 'Y1') {
            if (!keys.includes('PY')) {
                doc[ris_model['PY']] = value
            } else {
                let index_PY = keys.indexOf('PY')
                let is_exist = !!values[index_PY]
                if (!is_exist) { doc[ris_model['PY']] = value }
            }
        }
        if (tags.includes(key)) {
            bt_key = ris_model[key]

            // People
            let people_type_list = Object.keys(people_types)
            if (people_type_list.includes(bt_key)) {
                let lastname = value.split(',')[0].trim()
                let firstname = value.split(',').length > 1 ? value.split(',')[1].trim() : ""
                if (doc[bt_key]) {
                    let num = doc[bt_key].length + 1
                    doc[bt_key].push({
                        lastname,
                        firstname,
                        ordinal_num: num
                    })
                } else {
                    doc[bt_key] = [{ lastname, firstname, ordinal_num: 1 }]
                }
            }

            // Keywords
            else if (bt_key == 'keywords') {
                if (doc[bt_key]) {
                    doc[bt_key] += ";" + value
                } else {
                    doc[bt_key] = value
                }
            }

            //languages
            else if (bt_key == 'lang') {
                for (let lnkey in languages) {
                    let names = languages[lnkey].names
                    let value_lc = value.toLowerCase()
                    if (names.includes(value_lc)) {
                        doc[bt_key] = lnkey
                    }
                }
                if (!doc[bt_key]) {
                    doc[bt_key] = 'xx'
                }
            }

            // Volume & Issue
            else if (bt_key == 'issue') {
                if (!!value) {
                    if (!!doc['volume'] && doc['volume'] != 'null') {
                        doc['volume'] += "(" + value + ")"
                    } else {
                        doc['volume'] = "(" + value + ")"
                    }
                }
            } else if (bt_key == 'volume') {
                if (!!value && value != 'null') {
                    if (!!doc[bt_key]) {
                        doc[bt_key] = value + doc[bt_key]
                    } else {
                        doc[bt_key] = value
                    }
                }
            }

            // Date
            else if (bt_key == 'date' || bt_key == 'statistics_date') {
                doc[bt_key] = value
                let date_ids = [100, 101, 102, 104, 999]
                if (date_ids.includes(type_id)) {
                    doc['publishing_date'] = value
                } else if (type_id == 110) {
                    doc['year'] = value
                }
            }

            // Pages
            else if (bt_key == 'page_start' || bt_key == 'page_end') {
                if (doc['pages']) {
                    if (bt_key == 'page_start') {
                        doc['pages'] = value + "-" + doc['pages']
                    } else {
                        doc['pages'] += "-" + value
                    }
                } else {
                    doc['pages'] = value
                }
            } else { doc[bt_key] = value }
        }
    }

    // console.log('doc', JSON.parse(JSON.stringify(doc)))

    // Revise the form
    let result_doc = returnDocObj(doc['doc_type'])
    Object.keys(result_doc).forEach(function(key) {
        if (key in doc) {
            result_doc[key] = doc[key]
        }
    })
    return result_doc
}

export function checkDuplicate(obj, arr) {
    let result = false
    for (let i = 0; i < arr.length; i++) {
        result = (JSON.stringify(obj) == JSON.stringify(arr[i])) || result
    }
    return result
}

// export function checkRequiredField(obj) {
//     let result = true
//     let keys = Object.keys(obj).filter(v => titles.includes(v))
//     if (!!keys.length) {
//         for (let i = 0; i < keys.length; i++) {
//             result = !!obj[keys[i]] && result
//         }
//     } else { result = false }
//     return result
// }

export function checkRequiredField(obj) {
    let result = true
    let required_fields = doc_types[obj.doc_type].required_fields
    let people_fields = Object.keys(people_types)
    let doc = deleteEmptyFields(obj)
    let keys = Object.keys(doc)
    let title = required_fields.find(v => titles.includes(v))
    let author = required_fields.find(v => people_fields.includes(v))
    let date = required_fields.find(v => dates.includes(v))
    if (!keys.includes(title) || !keys.includes(author) || !keys.includes(date)) {
        result = false
    }
    return result
}

// Not showed

export function getDayDiff(str) {
    let day = 24 * 60 * 60 * 1000
    let now = new Date()
    let date = new Date(str.split(' ')[0])

    return Math.round((now.getTime() - date.getTime()) / (day))
}

export function getTimeDiff(str) {
    let day = 24 * 60 * 60 * 1000
    let now = new Date()
    if (!!str) {
        let date = new Date(str.split(' ')[0])
        let time = str.split(' ')[1]

        let date_diff = Math.floor(Math.abs((now.getTime() - date.getTime()) / (day)))
        let year_diff = now.getFullYear() - date.getFullYear()
        let month_diff = now.getMonth() - date.getMonth()

        if (year_diff > 0) {
            return year_diff == 1 ? year_diff + 'year ago' : year_diff + 'years ago'
        } else if (month_diff > 0) {
            return month_diff == 1 ? month_diff + 'month ago' : month_diff + 'months ago'
        } else if (date_diff > 0) {
            return date_diff == 1 ? 'yesterday' : date_diff + 'days ago'
        } else {
            return 'today'
        }
    }
    return null
}

export function getLocalTime() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    return (new Date(Date.now() - tzoffset))
        .toISOString().slice(0, -1).substr(0, 10)
}

export function sortNotes(input_notes, key) {
    let notes = JSON.parse(JSON.stringify(input_notes))
    return notes.sort(function(a, b) {
        switch (key) {
            case 0:
                // Authors (ascending)
                if (a.authors_iso690 < b.authors_iso690)
                    return -1;
                if (a.authors_iso690 > b.authors_iso690)
                    return 1;
                return 0;
                break;
            case 1:
                // Authors (descending)
                if (a.authors_iso690 > b.authors_iso690)
                    return -1;
                if (a.authors_iso690 < b.authors_iso690)
                    return 1;
                return 0;
                break;
            case 2:
                // Year (ascending)
                if (a.year < b.year)
                    return -1;
                if (a.year > b.year)
                    return 1;
                return 0;
                break;
            case 3:
                // Year (descending)
                if (a.year > b.year)
                    return -1;
                if (a.year < b.year)
                    return 1;
                return 0;
                break;
            case 4:
                // Title (ascending)
                if (a.title < b.title)
                    return -1;
                if (a.title > b.title)
                    return 1;
                return 0;
                break;
            case 5:
                // Title (descending)
                if (a.title > b.title)
                    return -1;
                if (a.title < b.title)
                    return 1;
                return 0;
                break;
            case 6:
                // Modefied_ts (ascending)
                if (a.modified_ts < b.modified_ts)
                    return -1;
                if (a.modified_ts > b.modified_ts)
                    return 1;
                return 0;
                break;
            case 7:
                // Modified_ts (descending)
                if (a.modified_ts > b.modified_ts)
                    return -1;
                if (a.modified_ts < b.modified_ts)
                    return 1;
                return 0;
                break;
        }
    })
}

export function sortDocuments(input_docs, key) {
    let docs = JSON.parse(JSON.stringify(input_docs))
    return docs.sort(function(a, b) {
        switch (key) {
            case 0:
                // Title (ascending)
                if (a.title < b.title)
                    return -1;
                if (a.title > b.title)
                    return 1;
                return 0;
                break;

            case 1:
                // Title (descending)
                if (a.title > b.title)
                    return -1;
                if (a.title < b.title)
                    return 1;
                return 0;
                break;

            case 2:
                // Year (newest first)
                if (!!a.date) {
                    if (a.date > b.date)
                        return -1;
                    if (a.date < b.date)
                        return 1;
                } else {
                    if (a.year > b.year)
                        return -1;
                    if (a.year < b.year)
                        return 1;
                }
                return 0;
                break;

            case 3:
                // Year (oldest first)
                if (!!a.date) {
                    if (a.date < b.date)
                        return -1;
                    if (a.date > b.date)
                        return 1;
                } else {
                    if (a.year < b.year)
                        return -1;
                    if (a.year > b.year)
                        return 1;
                }
                return 0;
                break;

            case 4:
                // Author (ascending)
                if (a.authors[0].iso690 < b.authors[0].iso690)
                    return -1;
                if (a.authors[0].iso690 > b.authors[0].iso690)
                    return 1;
                return 0;
                break;

            case 5:
                // Author (descending)
                if (a.authors[0].iso690 > b.authors[0].iso690)
                    return -1;
                if (a.authors[0].iso690 < b.authors[0].iso690)
                    return 1;
                return 0;
                break;
        }
    })
}

export function divideText(type, style, text) {
    let txt = text.trim()
    let arr = []
    let keys = []
    let values = []
    let doc = {
        doc_type: type
    }

    try {
        switch (style) {
            case 'apa':
                switch (type) {
                    case 105:
                        // 연구자명. (발행년). 논문명. 자료명(발행단체명), 권(호), 논문수록면수.
                        let arr_year = txt.match(/\((\d{4})\)/)
                        doc['date'] = arr_year[1]
                        let authors = txt.split(arr_year[0])[0].trim().split('.,')
                        doc['authors'] = authors.map(function(d) {
                            let arr_authors = d.split(/,|&/)
                            if (arr_authors.length == 2) {
                                return {
                                    lastname: arr_authors[0].trim(),
                                    firstname: arr_authors[1].trim()
                                }
                            } else {
                                return {
                                    lastname: arr_authors[1].trim(),
                                    firstname: arr_authors[2].trim()
                                }
                            }
                        })
                        doc['article_title'] = txt.split(arr_year[0])[1].split('.')[1].trim()
                        let others = txt.split(doc['article_title'])[1].split('.')[1].split(',')
                        doc['journal_name'] = others[0].trim()
                        doc['volume'] = others[1].trim()
                        doc['pages'] = others[2].trim()
                        break;
                }
        }
    } catch (e) {
        console.warn(e)
    }
    return doc
}

export function returnDocDetail(doc, type) {
    let return_doc = {}
    switch (type) {
        case 0:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.book_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: null,
                number: doc.volume,
                edition: doc.edition,
                pages: null,
                URL: doc.URL,
                DOI: doc.DOI,
                description: doc.contents,
                keywords: doc.keywords,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.publisher,
                paper_ebook: doc.paper_ebook,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 1:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: null,
                number: null,
                edition: doc.diplome_title,
                pages: null,
                URL: doc.URL,
                DOI: doc.DOI,
                description: doc.contents,
                keywords: doc.keywords,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.university,
                department: doc.department,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 2:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.document_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: null,
                number: doc.number,
                edition: doc.document_category,
                pages: null,
                URL: doc.URL,
                DOI: doc.DOI,
                description: doc.contents,
                keywords: doc.keywords,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.institution,
                department: doc.department,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 3:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.law_title,
                authors: doc.authors,
                author_c: null,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: null,
                number: doc.number,
                edition: doc.version,
                pages: null,
                URL: doc.URL,
                DOI: null,
                description: doc.contents,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.institution,
                law_category: doc.law_category,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 4:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.statistics_title,
                authors: doc.authors,
                author_c: null,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: null,
                number: null,
                edition: doc.provisional_confirmed,
                pages: null,
                URL: doc.URL,
                DOI: null,
                description: doc.description,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.institution,
                paper_online: doc.paper_online,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 5:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.issue_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: doc.journal_name,
                number: doc.volume,
                edition: null,
                pages: null,
                URL: doc.URL,
                DOI: null,
                description: doc.contents,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.institution,
                paper_online: doc.paper_online,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 6:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.issue_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: doc.conference_name,
                number: doc.numberth,
                edition: doc.session,
                pages: null,
                URL: doc.URL,
                DOI: doc.DOI,
                description: doc.contents,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.institution,
                place: doc.place,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 7:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.article_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: doc.newspaper_name,
                number: doc.number,
                edition: doc.morning_afternoon,
                pages: null,
                URL: doc.URL,
                DOI: doc.DOI,
                description: doc.description,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.company,
                paper_online: doc.paper_online,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 8:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.issue_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: doc.magazine_name,
                number: doc.number,
                edition: null,
                pages: null,
                URL: doc.URL,
                DOI: null,
                description: doc.contents,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.publisher,
                paper_online: doc.paper_online,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 9:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.album_name,
                authors: doc.creators,
                author_c: doc.creator_c,
                authors_iso690: doc.creators_iso690,
                date: doc.date,
                publication: null,
                number: null,
                edition: null,
                pages: null,
                URL: doc.URL,
                DOI: null,
                description: doc.contents,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.label,
                dvd_online: doc.dvd_online,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 10:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.film_title,
                authors: doc.directors,
                author_c: doc.director_c,
                authors_iso690: doc.directors_iso690,
                date: doc.date,
                publication: doc.film_title,
                number: null,
                edition: null,
                pages: null,
                URL: doc.URL,
                DOI: null,
                description: doc.description,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.production,
                film_note: doc.film_note,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 100:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.chapter_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: doc.book_title,
                number: doc.volume,
                edition: doc.edition,
                pages: doc.pages,
                URL: doc.URL_chapter,
                pub_URL: doc.URL_book,
                DOI: doc.DOI_chapter,
                pub_DOI: doc.DOI_book,
                description: doc.description,
                keywords: doc.keywords,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.publisher,
                pub_date: doc.publishing_date,
                other_idf: doc.other_idf,
                paper_ebook: doc.paper_ebook,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 101:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.chapter_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: doc.book_title,
                number: null,
                edition: doc.diplome_title,
                pages: doc.pages,
                URL: doc.URL_chapter,
                pub_URL: doc.URL_thesis,
                DOI: doc.DOI_chapter,
                pub_DOI: doc.DOI_thesis,
                description: doc.description,
                keywords: doc.keywords,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.university,
                pub_date: doc.publishing_date,
                other_idf: doc.other_idf,
                department: doc.department,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 102:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.article_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: doc.document_title,
                number: doc.number,
                edition: doc.document_category,
                pages: doc.pages,
                URL: doc.URL_article,
                pub_URL: doc.URL_report,
                DOI: doc.DOI_chapter,
                pub_DOI: doc.DOI_document,
                description: doc.description,
                keywords: doc.keywords,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.institution,
                pub_date: doc.publishing_date,
                other_idf: doc.other_idf,
                department: doc.department,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 103:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.article_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: doc.law_title,
                number: doc.number,
                edition: doc.version,
                pages: doc.article_number,
                URL: doc.URL_article,
                pub_URL: doc.URL_law,
                DOI: null,
                pub_DOI: null,
                description: doc.description,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.institution,
                pub_date: null,
                other_idf: doc.other_idf,
                law_category: doc.law_category,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 104:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.table_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.statistics_date,
                publication: doc.statistics_title,
                number: null,
                edition: doc.provisional_confirmed,
                pages: null,
                URL: doc.URL_table,
                pub_URL: doc.URL_statistics,
                DOI: null,
                pub_DOI: null,
                description: doc.description,
                keywords: doc.keywords,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.institution,
                pub_date: doc.publishing_date,
                other_idf: doc.other_idf,
                paper_online: doc.paper_online,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 105:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.article_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: doc.journal_name,
                number: doc.volume,
                edition: null,
                pages: doc.pages,
                URL: doc.URL_article,
                pub_URL: doc.URL_journal,
                DOI: doc.DOI_article,
                pub_DOI: null,
                description: doc.abstract,
                keywords: doc.keywords,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.institution,
                pub_date: null,
                other_idf: doc.other_idf,
                paper_online: doc.paper_online,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 106:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.article_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.address_date,
                publication: doc.conference_name,
                number: doc.numberth,
                edition: doc.session,
                pages: doc.pages,
                URL: doc.URL_article,
                pub_URL: doc.URL_conference,
                DOI: doc.DOI_paper,
                pub_DOI: doc.DOI_proceeding,
                description: doc.abstract,
                keywords: doc.keywords,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.institution,
                con_dates: doc.conference_dates,
                other_idf: doc.other_idf,
                place: doc.place,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 107:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.article_title,
                authors: doc.reporters,
                author_c: doc.author_c,
                authors_iso690: doc.reporters_iso690,
                date: doc.date,
                publication: doc.newspaper_name,
                number: doc.number,
                edition: doc.morning_afternoon,
                pages: doc.pages,
                URL: doc.URL_article,
                pub_URL: doc.URL_newspaper,
                DOI: doc.DOI,
                pub_DOI: null,
                description: doc.description,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.company,
                pub_date: null,
                other_idf: doc.other_idf,
                paper_online: doc.paper_online,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 108:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.article_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: doc.magazine_name,
                number: doc.number,
                edition: null,
                pages: doc.pages,
                URL: doc.URL_article,
                pub_URL: doc.URL_magazine,
                DOI: doc.DOI_article,
                pub_DOI: null,
                description: doc.description,
                keywords: doc.keywords,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.publisher,
                pub_date: null,
                other_idf: doc.other_idf,
                paper_online: doc.paper_online,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 109:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.music_title,
                authors: doc.creators,
                author_c: doc.creator_c,
                authors_iso690: doc.creators_iso690,
                date: doc.date,
                publication: doc.album_name,
                number: null,
                edition: null,
                pages: null,
                URL: doc.URL_music,
                pub_URL: doc.URL_album,
                DOI: null,
                pub_DOI: null,
                description: doc.description,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.label,
                pub_date: null,
                other_idf: doc.other_idf,
                dvd_online: doc.dvd_online,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 110:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.episode_title,
                authors: doc.directors,
                author_c: doc.director_c,
                authors_iso690: doc.directors_iso690,
                date: doc.date,
                publication: doc.film_title,
                number: null,
                edition: null,
                pages: doc.episode_number,
                URL: doc.URL_episode,
                pub_URL: doc.URL_film,
                DOI: null,
                pub_DOI: null,
                description: doc.description,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.production,
                pub_date: doc.year,
                other_idf: doc.other_idf,
                film_note: doc.film_note,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        case 901:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.sub_title,
                authors: doc.makers,
                author_c: doc.maker_c,
                authors_iso690: doc.makers_iso690,
                date: doc.date,
                publication: doc.map_title,
                number: null,
                edition: doc.map_size,
                pages: null,
                URL: doc.URL_map,
                pub_URL: doc.URL_publication,
                DOI: doc.DOI,
                pub_DOI: null,
                description: doc.description,
                keywords: null,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.publisher,
                pub_date: null,
                other_idf: doc.other_idf,
                paper_digital: doc.paper_digital,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
            break;
        default:
            return_doc = {
                key: doc.key,
                doc_type: type,
                title: doc.sub_title,
                authors: doc.authors,
                author_c: doc.author_c,
                authors_iso690: doc.authors_iso690,
                date: doc.date,
                publication: doc.publication_title,
                number: doc.number,
                edition: doc.edition,
                pages: doc.pages,
                URL: doc.URL,
                URL: doc.URL_publication,
                DOI: doc.DOI,
                pub_DOI: doc.DOI_publication,
                description: doc.description,
                keywords: doc.keywords,
                star: doc.star,
                tags: doc.tags,
                publisher: doc.publisher,
                pub_date: doc.publishing_date,
                other_idf: doc.other_idf,
                etc_note: doc.etc_note,
                note: doc.note,
                has_note: doc.has_note,
                num_refs: doc.num_refs
            }
    }
    // Change the doc form
    if (return_doc.keywords != null) {
        return_doc.keywords = return_doc.keywords.split(";")
    }
    if (return_doc.number != null) {
        let number_last2 = return_doc.number.slice(-2)
        let number_last3 = return_doc.number.slice(-3)
        let number_first2 = return_doc.number.slice(0, 2)
        if (number_last2 == '()') {
            return_doc.number = return_doc.number.slice(0, -2)
        }
        if (number_last3 == '(-)') {
            return_doc.number = return_doc.number.slice(0, -3)
        }
        if (number_first2 == '0(') {
            return_doc.number = return_doc.number.slice(1)
        }
    }
    return return_doc
}

export function returnDocName(type) {
    let return_obj = {}
    let doc_obj = returnDocObj(type)
    let keys = Object.keys(doc_obj)

    let model = {
        doc_type: {
            name: "Document Type"
        },
        authors: {
            name: "Authors"
        },
        creators: {
            name: "Creators"
        },
        directors: {
            name: "Directors"
        },
        reporters: {
            name: "Reporters"
        },
        makers: {
            name: "Makers"
        },
        author_c: {
            name: "et al."
        },
        creator_c: {
            name: "et al."
        },
        director_c: {
            name: "et al."
        },
        maker_c: {
            name: "et al."
        },
        date: {
            name: "Date"
        },
        statistics_date: {
            name: "Statistics Date"
        },
        address_date: {
            name: "Address Date"
        },
        book_title: {
            name: "Book Title"
        },
        title: {
            name: "Title"
        },
        document_title: {
            name: "Document Title"
        },
        law_title: {
            name: "Law Title"
        },
        statistics_title: {
            name: "Statistics Title"
        },
        issue_title: {
            name: "Issue Title"
        },
        album_name: {
            name: "Album Name"
        },
        film_title: {
            name: "Film Title"
        },
        chapter_title: {
            name: "Chapter Title"
        },
        article_title: {
            name: "Article Title"
        },
        table_title: {
            name: "Table Title"
        },
        music_title: {
            name: "Music Title"
        },
        episode_title: {
            name: "Episode Title"
        },
        sub_title: {
            name: "Title"
        },
        lang: {
            name: "Language"
        },
        contents: {
            name: "Contents"
        },
        description: {
            name: "Description"
        },
        abstract: {
            name: "Abstract"
        },
        keywords: {
            name: "Keywords"
        },
        DOI: {
            name: "DOI"
        },
        DOI_chapter: {
            name: "Chapter DOI"
        },
        DOI_paper: {
            name: "Paper DOI"
        },
        DOI_article: {
            name: "Article DOI"
        },
        URL: {
            name: "URL"
        },
        URL_chapter: {
            name: "Chapter URL"
        },
        URL_article: {
            name: "URL"
        },
        URL_table: {
            name: "Table URL"
        },
        URL_music: {
            name: "Music URL"
        },
        URL_episode: {
            name: "Episode URL"
        },
        URL_map: {
            name: "Map URL"
        },
        journal_name: {
            name: "Journal"
        },
        conference_name: {
            name: "Conference Name"
        },
        newspaper_name: {
            name: "Newspaper Name"
        },
        magazine_name: {
            name: "Magazine Name"
        },
        newspaper_name: {
            name: "Newspaper Name"
        },
        magazine_name: {
            name: "Magazine Name"
        },
        album_name: {
            name: "Album Name"
        },
        film_title: {
            name: "Film Title"
        },
        map_title: {
            name: "Map Title"
        },
        publication_title: {
            name: "Publication Title"
        },
        number: {
            name: "Number"
        },
        numberth: {
            name: "Numberth"
        },
        volume: {
            name: "Volume(Issue)"
        },
        pages: {
            name: "Pages"
        },
        article_number: {
            name: "Article Number"
        },
        episode_number: {
            name: "Episode Number"
        },
        edition: {
            name: "Edition"
        },
        document_category: {
            name: "Document Category"
        },
        version: {
            name: "Version"
        },
        provisional_confirmed: {
            name: "Provisional Confirmed"
        },
        session: {
            name: "Session"
        },
        morning_afternoon: {
            name: "Morning or Afternoon"
        },
        diplome_title: {
            name: "Diplome Type"
        },
        map_size: {
            name: "Map Size"
        },
        publisher: {
            name: "Publisher"
        },
        university: {
            name: "University"
        },
        institution: {
            name: "Publisher"
        },
        company: {
            name: "Company"
        },
        label: {
            name: "Label"
        },
        production: {
            name: "Production"
        },
        DOI_book: {
            name: "Book DOI"
        },
        DOI_thesis: {
            name: "Thesis DOI"
        },
        DOI_document: {
            name: "Document DOI"
        },
        DOI_proceeding: {
            name: "Proceeding DOI"
        },
        DOI_publication: {
            name: "Publication DOI"
        },
        OCLC: {
            name: "OCLC"
        },
        ISBN: {
            name: "ISBN"
        },
        ISSN: {
            name: "ISSN"
        },
        URL_book: {
            name: "Book URL"
        },
        URL_thesis: {
            name: "Thesis URL"
        },
        URL_report: {
            name: "Report URL"
        },
        URL_law: {
            name: "Law URL"
        },
        URL_statistics: {
            name: "Statistics URL"
        },
        URL_journal: {
            name: "Journal URL"
        },
        URL_conference: {
            name: "Conference URL"
        },
        URL_newspaper: {
            name: "Newspaper URL"
        },
        URL_magazine: {
            name: "Magazine URL"
        },
        URL_album: {
            name: "Album URL"
        },
        URL_film: {
            name: "Film URL"
        },
        URL_publication: {
            name: "Publication URL"
        },
        editors: {
            name: "Editors"
        },
        juries: {
            name: "Juries"
        },
        editor_c: {
            name: "et al."
        },
        jury_c: {
            name: "et al."
        },
        translators: {
            name: "Translators"
        },
        translator_c: {
            name: "et al."
        },
        publishing_date: {
            name: "Publishing Date"
        },
        conference_dates: {
            name: "Conference Dates"
        },
        year: {
            name: "Year"
        },
        paper_ebook: {
            name: "E-book"
        },
        department: {
            name: "Department"
        },
        law_category: {
            name: "Law Category"
        },
        paper_online: {
            name: "Online Paper"
        },
        place: {
            name: "Place"
        },
        dvd_online: {
            name: "Online DVD"
        },
        note: {
            name: "Note"
        },
        other_idf: {
            name: "Other Identifiers"
        },
        paper_digital: {
            name: "Digital Paper"
        },
    }

    for (let i = 0; i < keys.length; i++) {
        let key = keys[i]
        return_obj[key] = JSON.parse(JSON.stringify(model[key]))
    }

    return return_obj
}

export function returnRisModel(type) {
    switch (type) {
        case 0:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "book_title",
                "TI": "book_title",
                "LA": "lang",
                "AB": "contents",
                "KW": "keywords",
                "DO": "DOI",
                "UR": "URL",
                "VL": "volume",
                "ET": "edition",
                "PB": "publisher",
                "SN": "ISBN",
                "ED": "editors",
                "TA": "translators",
            }
            break;
        case 1:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "title",
                "TI": "title",
                "LA": "lang",
                "AB": "contents",
                "KW": "keywords",
                "DO": "DOI",
                "UR": "URL",
                "PB": "university",
                "TA": "translators",
            }
            break;
        case 2:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "document_title",
                "TI": "document_title",
                "LA": "lang",
                "AB": "contents",
                "KW": "keywords",
                "DO": "DOI",
                "UR": "URL",
                "VL": "number",
                "ET": "document_category",
                "PB": "institution",
                "SN": "ISBN",
                "ED": "editors",
                "TA": "translators",
            }
            break;
        case 3:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "law_title",
                "TI": "law_title",
                "LA": "lang",
                "AB": "contents",
                "UR": "URL",
                "VL": "number",
                "ED": "version",
                "PB": "institution",
                "TA": "translators",
            }
            break;
        case 4:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "statistics_title",
                "TI": "statistics_title",
                "LA": "lang",
                "AB": "description",
                "UR": "URL",
                "PB": "institution",
            }
            break;
        case 5:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "issue_title",
                "TI": "issue_title",
                "LA": "lang",
                "AB": "contents",
                "UR": "URL",
                "T2": "journal_name",
                "JO": "journal_name",
                "VL": "volume",
                "IS": "issue",
                "PB": "institution",
                "SN": "ISSN",
                "ED": "editors",
            }
            break;
        case 6:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "issue_title",
                "TI": "issue_title",
                "LA": "lang",
                "AB": "contents",
                "DO": "DOI",
                "UR": "URL",
                "T2": "conference_name",
                "PB": "institution",
                "SN": "ISBN",
                "ED": "editors",
                "CY": "place",
                "PP": "place",
            }
            break;
        case 7:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "article_title",
                "TI": "article_title",
                "LA": "lang",
                "AB": "description",
                "DO": "DOI",
                "UR": "URL",
                "T2": "newspaper_name",
                "PB": "company",
                "SN": "ISSN"
            }
            break;
        case 8:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "issue_title",
                "TI": "issue_title",
                "LA": "lang",
                "AB": "contents",
                "UR": "URL",
                "T2": "magazine_name",
                "JO": "magazine_name",
                "VL": "number",
                "PB": "publisher",
                "SN": "ISSN",
                "ED": "editors",
            }
            break;
        case 9:
            return {
                "AU": "creators",
                "A1": "creators",
                "PY": "date",
                "T1": "album_name",
                "TI": "album_name",
                "LA": "lang",
                "AB": "contents",
                "UR": "URL",
                "PB": "label",
            }
            break;
        case 10:
            return {
                "AU": "directors",
                "A1": "directors",
                "PY": "date",
                "T1": "film_title",
                "TI": "film_title",
                "LA": "lang",
                "AB": "description",
                "UR": "URL",
                "PB": "production",
                "TA": "translators"
            }
            break;
        case 100:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "chapter_title",
                "TI": "chapter_title",
                "LA": "lang",
                "AB": "description",
                "KW": "keywords",
                "DO": "DOI_chapter",
                "UR": "URL_chapter",
                "T2": "book_title",
                "BT": "book_title",
                "VL": "volume",
                "SP": "page_start",
                "EP": "page_end",
                "ET": "edition",
                "PB": "publisher",
                "SN": "ISBN",
                "ED": "editors",
                "TA": "translators",
            }
            break;
        case 101:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "chapter_title",
                "TI": "chapter_title",
                "LA": "lang",
                "AB": "description",
                "KW": "keywords",
                "DO": "DOI_chapter",
                "UR": "URL_chapter",
                "T1": "title",
                "TI": "title",
                "SP": "page_start",
                "EP": "page_end",
                "PB": "university",
            }
            break;
        case 102:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "article_title",
                "TI": "article_title",
                "LA": "lang",
                "KW": "keywords",
                "DO": "DOI_article",
                "UR": "URL_article",
                "T2": "document_title",
                "BT": "document_title",
                "VL": "number",
                "SP": "page_start",
                "EP": "page_end",
                "PB": "institution",
                "SN": "ISBN",
                "ED": "editors",
            }
            break;
        case 103:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "article_title",
                "TI": "article_title",
                "LA": "lang",
                "AB": "description",
                "UR": "URL_article",
                "T1": "law_title",
                "TI": "law_title",
                "VL": "number",
                "ET": "version",
                "PB": "institution",
            }
            break;
        case 104:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "statistics_date",
                "T1": "table_title",
                "TI": "table_title",
                "LA": "lang",
                "AB": "description",
                "UR": "URL_table",
                "T2": "statistics_title",
                "PB": "institution",
            }
            break;
        case 105:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "article_title",
                "TI": "article_title",
                "LA": "lang",
                "AB": "abstract",
                "KW": "keywords",
                "DO": "DOI_article",
                "UR": "URL_article",
                "T2": "journal_name",
                "JO": "journal_name",
                "VL": "volume",
                "IS": "issue",
                // Pages start-end
                "SP": "page_start",
                "EP": "page_end",
                "PB": "institution",
                "SN": "ISSN",
                "ED": "editors",
                "TA": "translators",
            }
            break;
        case 106:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "address_date",
                "T1": "article_title",
                "TI": "article_title",
                "LA": "lang",
                "AB": "abstract",
                "KW": "keywords",
                "DO": "DOI_paper",
                "UR": "URL_article",
                "T2": "conference_name",
                "SP": "page_start",
                "EP": "page_end",
                "PB": "institution",
                "SN": "ISBN",
                "ED": "editors",
                "TA": "translators",
                "CY": "place",
                "PP": "place",
            }
            break;
        case 107:
            return {
                "AU": "reporters",
                "A1": "reporters",
                "PY": "date",
                "T1": "article_title",
                "TI": "article_title",
                "LA": "lang",
                "AB": "description",
                "DO": "DOI",
                "UR": "URL_article",
                "T2": "newspaper_name",
                "SP": "page_start",
                "EP": "page_end",
                "PB": "company",
                "SN": "ISSN",
                "TA": "translators",
            }
            break;
        case 108:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "article_title",
                "TI": "article_title",
                "LA": "lang",
                "AB": "description",
                "KW": "keywords",
                "DO": "DOI_article",
                "UR": "URL_article",
                "T2": "magazine_name",
                "JO": "magazine_name",
                "SP": "page_start",
                "EP": "page_end",
                "PB": "publisher",
                "SN": "ISSN",
                "ED": "editors",
                "TA": "translators",
            }
            break;
        case 109:
            return {
                "AU": "creators",
                "A1": "authors",
                "PY": "date",
                "T1": "music_title",
                "TI": "music_title",
                "LA": "lang",
                "AB": "description",
                "UR": "URL_music",
                "T2": "album_name",
                "PB": "label",
            }
            break;
        case 110:
            return {
                "AU": "directors",
                "A1": "directors",
                "PY": "date",
                "T1": "episode_title",
                "TI": "episode_title",
                "LA": "lang",
                "AB": "description",
                "UR": "URL_episode",
                "T2": "film_title",
                "PB": "production",
                "TA": "translators",
            }
            break;
        case 901:
            return {
                "AU": "makers",
                "A1": "makers",
                "PY": "date",
                "T1": "sub_title",
                "TI": "sub_title",
                "LA": "lang",
                "AB": "description",
                "DO": "DOI",
                "UR": "URL_map",
                "T2": "map_title",
                "PB": "publisher",
            }
            break;
        default:
            return {
                "AU": "authors",
                "A1": "authors",
                "PY": "date",
                "T1": "sub_title",
                "TI": "sub_title",
                "LA": "lang",
                "AB": "description",
                "KW": "keywords",
                "DO": "DOI",
                "UR": "URL",
                "T2": "publication_title",
                "BT": "publication_title",
                "VL": "number",
                "SP": "page_start",
                "EP": "page_end",
                "ET": "edition",
                "PB": "publisher",
                "SN": "ISBN",
                "ED": "editors",
                "TA": "translators",
            }
    }
}

export function returnEnwModel(type) {
    switch (type) {
        case 0:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "book_title",
                "%G": "lang",
                "%X": "contents",
                "%K": "keywords",
                "%R": "DOI",
                "%U": "URL",
                "%V": "volume",
                "%7": "edition",
                "%I": "publisher",
                "%@": "ISBN",
                "%E": "editors",
                "%H": "translators"
            }
            break;
        case 1:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "title",
                "%G": "lang",
                "%X": "contents",
                "%K": "keywords",
                "%R": "DOI",
                "%U": "URL",
                "%I": "university",
                "%E": "juries",
                "%H": "translators"
            }
            break;
        case 2:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "document_title",
                "%G": "lang",
                "%X": "contents",
                "%K": "keywords",
                "%R": "DOI",
                "%U": "URL",
                "%N": "number",
                "%I": "publisher",
                "%@": "ISBN",
                "%E": "editors",
                "%H": "translators"
            }
            break;
        case 3:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "law_title",
                "%G": "lang",
                "%X": "contents",
                "%U": "URL",
                "%N": "number",
                "%7": "version",
                "%I": "institution",
                "%H": "translators"
            }
            break;
        case 4:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "statistics_title",
                "%G": "lang",
                "%X": "description",
                "%U": "URL",
                "%7": "provisional_confirmed",
                "%I": "institution",
            }
            break;
        case 5:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "issue_title",
                "%G": "lang",
                "%X": "contents",
                "%U": "URL",
                "%J": "journal_name",
                "%V": "volume",
                "%I": "institution",
                "%@": "ISSN",
                "%E": "editors"
            }
            break;
        case 6:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "issue_title",
                "%G": "lang",
                "%X": "contents",
                "%R": "DOI",
                "%U": "URL",
                "%B": "conference_name",
                "%N": "numberth",
                "%I": "institution",
                "%@": "ISBN",
                "%E": "editors",
                "%C": "place"
            }
            break;
        case 7:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "article_title",
                "%G": "lang",
                "%X": "description",
                "%R": "DOI",
                "%U": "URL",
                "%B": "newspaper_name",
                "%N": "number",
                "%I": "company",
                "%@": "ISSN"
            }
            break;
        case 8:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "issue_title",
                "%G": "lang",
                "%X": "contents",
                "%U": "URL",
                "%B": "magazine_name",
                "%N": "number",
                "%I": "publisher",
                "%@": "ISSN",
                "%E": "editors"
            }
            break;
        case 9:
            return {
                "%A": "creators",
                "%D": "date",
                "%T": "album_name",
                "%G": "lang",
                "%X": "contents",
                "%U": "URL",
                "%I": "label"
            }
            break;
        case 10:
            return {
                "%A": "directors",
                "%D": "date",
                "%T": "film_title",
                "%G": "lang",
                "%X": "description",
                "%U": "URL",
                "%I": "production",
                "%H": "translators"
            }
            break;
        case 100:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "chapter_title",
                "%G": "lang",
                "%X": "description",
                "%K": "keywords",
                "%R": "DOI_chapter",
                "%B": "book_title",
                "%V": "volume",
                "%P": "pages",
                "%I": "publisher",
                "%@": "ISBN",
                "%E": "editors",
                "%H": "translators",
                "%8": "publishing_date"
            }
            break;
        case 101:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "chapter_title",
                "%G": "lang",
                "%X": "description",
                "%K": "keywords",
                "%R": "DOI_chapter",
                "%U": "URL_chapter",
                "%B": "title",
                "%P": "pages",
                "%I": "university",
                "%E": "juries",
                "%8": "publishing_date"
            }
            break;
        case 102:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "article_title",
                "%G": "lang",
                "%X": "description",
                "%K": "keywords",
                "%R": "DOI_article",
                "%U": "URL_article",
                "%B": "document_title",
                "%N": "number",
                "%P": "pages",
                "%I": "institution",
                "%@": "ISBN",
                "%E": "editors",
                "%8": "publishing_date"
            }
            break;
        case 103:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "article_title",
                "%G": "lang",
                "%X": "description",
                "%U": "URL_article",
                "%B": "law_title",
                "%N": "number",
                "%7": "version",
                "%I": "institution",
            }
            break;
        case 104:
            return {
                "%A": "authors",
                "%D": "statistics_date",
                "%T": "table_title",
                "%G": "lang",
                "%X": "description",
                "%U": "URL_table",
                "%B": "statistics_title",
                "%I": "institution",
                "%8": "publishing_date"
            }
            break;
        case 105:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "article_title",
                "%G": "lang",
                "%X": "abstract",
                "%K": "keywords",
                "%R": "DOI_article",
                "%U": "URL_article",
                "%J": "journal_name",
                "%V": "volume",
                "%N": "issue",
                "%P": "pages",
                "%I": "institution",
                "%@": "ISSN",
                "%E": "editors",
                "%H": "translators"
            }
            break;
        case 106:
            return {
                "%A": "authors",
                "%D": "address_date",
                "%T": "article_title",
                "%G": "lang",
                "%X": "abstract",
                "%K": "keywords",
                "%R": "DOI_paper",
                "%U": "URL_article",
                "%B": "conference_name",
                "%N": "numberth",
                "%P": "pages",
                "%I": "institution",
                "%@": "ISBN",
                "%E": "editors",
                "%H": "translators",
                "%8": "conference_dates",
                "%C": "place"
            }
            break;
        case 107:
            return {
                "%A": "reporters",
                "%D": "date",
                "%T": "article_title",
                "%G": "lang",
                "%X": "description",
                "%R": "DOI",
                "%U": "URL_article",
                "%B": "newspaper_name",
                "%N": "number",
                "%P": "pages",
                "%I": "company",
                "%@": "ISSN",
                "%H": "translators"
            }
            break;
        case 108:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "article_title",
                "%G": "lang",
                "%X": "description",
                "%K": "keywords",
                "%R": "DOI_article",
                "%U": "URL_article",
                "%B": "magazine_name",
                "%N": "number",
                "%P": "pages",
                "%I": "publisher",
                "%@": "ISSN",
                "%E": "editors",
                "%H": "translators"
            }
            break;
        case 109:
            return {
                "%A": "creators",
                "%D": "date",
                "%T": "music_title",
                "%G": "lang",
                "%X": "description",
                "%U": "URL_music",
                "%B": "album_name",
                "%I": "label",
            }
            break;
        case 110:
            return {
                "%A": "directors",
                "%D": "date",
                "%T": "episode_title",
                "%G": "lang",
                "%X": "description",
                "%U": "URL_episode",
                "%B": "film_title",
                "%I": "production",
                "%H": "translators"
            }
            break;
        case 901:
            return {
                "%A": "makers",
                "%D": "date",
                "%T": "sub_title",
                "%G": "lang",
                "%X": "description",
                "%R": "DOI",
                "%U": "URL_map",
                "%B": "map_title",
                "%I": "publisher"
            }
            break;
        default:
            return {
                "%A": "authors",
                "%D": "date",
                "%T": "sub_title",
                "%G": "lang",
                "%X": "description",
                "%K": "keywords",
                "%R": "DOI",
                "%U": "URL",
                "%B": "publication_title",
                "%N": "number",
                "%P": "pages",
                "%7": "edition",
                "%I": "publisher",
                "%@": "ISBN",
                "%E": "editors",
                "%H": "translators",
                "%8": "publishing_date"
            }
    }
}

export function deleteEmptyCols(doc) {
    Object.keys(doc).forEach(function(key) {
        let value = doc[key]
            // delete empty fields
        if ((value === null) ||
            (Array.isArray(value) && !value.length) ||
            (!Array.isArray(value) && value === "")) {
            delete doc[key]
        }
    })
    return doc
}

export function toDatetime(date) {
    let ten = function(i) {
        return (i < 10 ? '0' : '') + i
    }
    let YYYY = date.getFullYear()
    let MM = ten(date.getMonth() + 1)
    let DD = ten(date.getDate())
    let HH = ten(date.getHours())
    let II = ten(date.getMinutes())
    let SS = ten(date.getSeconds())
    return YYYY + '-' + MM + '-' + DD + ' ' + HH + ':' + II + ':' + SS
}

export function exportDoc(html, title_cab, title) {
    var header = "<!DOCTYPE html>" + "<head><meta charset='utf-8'></head><body>"
    var credit = "<div>@BiblioTrees</div>"
    var footer = "</body></html>"
    var content = header + credit + html + footer
    var converted = htmlDocx.asBlob(content)

    var filename = title_cab + title + '_' + getDateFormat(new Date()) + '.docx'

    var link = document.createElement('a')
    document.body.appendChild(link)
    link.href = URL.createObjectURL(converted);
    link.download = filename
    link.click()
    document.body.removeChild(link)
}

export function getDateFormat(date) {
    let ten = function(i) {
        return (i < 10 ? '0' : '') + i
    }
    let YYYY = date.getFullYear()
    let MM = ten(date.getMonth() + 1)
    let DD = ten(date.getDate())
    let HH = ten(date.getHours())
    let II = ten(date.getMinutes())
    return YYYY + MM + DD + '_' + HH + II
}

export function convertToCSV(data) {
    let result = ''
    let column_delimiter = ','
    let line_delimiter = '\n'
    let keys = Object.keys(data[0])

    if (data == null || !data.length) {
        return null
    } else {
        result += keys.join(column_delimiter)
        result += line_delimiter

        data.forEach((item) => {
            let ctr = 0
            keys.forEach((key) => {
                if (ctr > 0) { result += column_delimiter }
                let value = item[key] || ""
                result += value
                ctr++
            })
            result += line_delimiter
        })
        return result
    }
}

export function convertToArray(csv) {
    let result = []
    let column_delimiter = ','
    let line_delimiter = '\n'

    if (csv == null) { return null } else {
        let rows = csv.split(line_delimiter).map(el => el.trim()).filter(el => el !== '')
        let keys = rows[0].split(column_delimiter)
        for (let i = 1; i < rows.length; i++) {
            let row_arr = rows[i].split(column_delimiter)
            let row_obj = {}
            for (let j = 0; j < keys.length; j++) {
                row_obj[keys[j]] = row_arr[j]
            }
            result.push(JSON.parse(JSON.stringify(row_obj)))
        }
        return result
    }
}

export function convertBibToBT(type, keys, values) {
    let doc = {}
    let bib_model, tags

    let doc_type_keys = Object.keys(doc_types)
    let doc_type_values = Object.values(doc_types)

    let type_id = 999
    let type_index = doc_type_values
        .findIndex(el => el.keyname == type)
    if (type_index > -1) {
        type_id = parseInt(doc_type_keys[type_index])
    }

    // console.log('type_id', type_id)

    bib_model = returnBibModel(type_id)
    tags = Object.keys(bib_model)

    doc['doc_type'] = type_id

    // Concate year and month
    if (keys.includes('year') && keys.includes('month')) {
        let index_year = keys.indexOf('year')
        let index_month = keys.indexOf('month')
        values[index_year] = values[index_year] + '-' + values[index_month]
    }

    for (let i = 0; i < keys.length; i++) {
        let key, bt_key, value
        key = keys[i]
        value = values[i]

        if (tags.includes(key)) {
            bt_key = bib_model[key]

            // People
            let people_type_list = Object.keys(people_types)
            if (people_type_list.includes(bt_key)) {
                doc[bt_key] = []
                let people_array = value.split(/\s+and\s+/g)
                people_array = people_array.map(el => el.trim())
                people_array = people_array.filter(el => !!el.length)
                for (let j = 0; j < people_array.length; j++) {
                    let lastname = '',
                        firstname = ''
                    let person_array = people_array[j].split(' ')
                    if (person_array.length == 1) {
                        lastname = person_array[0]
                    } else {
                        lastname = person_array.pop()
                        firstname = person_array.join(' ').match(/[^,]+/g)[0]
                    }
                    doc[bt_key].push({
                        lastname,
                        firstname,
                        ordinal_num: j + 1
                    })
                }
            } else if (bt_key == 'number') {
                if (value != "") {
                    if (!doc['volume']) {
                        doc['volume'] = "(" + value + ")"
                    } else {
                        doc['volume'] += "(" + value + ")"
                    }
                }
            } else if (bt_key == 'volume') {
                if (!!doc[bt_key]) {
                    doc[bt_key] = value + doc[bt_key]
                } else {
                    doc[bt_key] = value
                }
            } else {
                doc[bt_key] = value
            }
        }
    }

    // Revise the form
    let result_doc = returnDocObj(doc['doc_type'])
    Object.keys(result_doc).forEach(function(key) {
        if (key in doc) {
            result_doc[key] = doc[key]
        }
    })
    return result_doc
}

export function returnBibModel(type) {
    switch (type) {
        case 0:
            return {
                "author": "authors",
                "booktitle": "book_title",
                "edition": "edition",
                "editor": "editors",
                "note": "contents",
                "publisher": "publisher",
                "title": "book_title",
                "volume": "volume",
                "number": "number",
                "year": "date",
            }
            break;
        case 1:
            return {
                "author": "authors",
                "note": "contents",
                "school": "university",
                "title": "title",
                "year": "date",
            }
            break;
        case 2:
            return {
                "author": "authors",
                "editor": "editors",
                "note": "contents",
                "number": "number",
                "institution": "institution",
                "organization": "institution",
                "publisher": "institution",
                "title": "document_title",
                "year": "date",
            }
            break;
        case 3:
            return {
                "author": "authors",
                "edition": "version",
                "note": "contents",
                "number": "number",
                "institution": "institution",
                "organization": "institution",
                "publisher": "institution",
                "title": "law_title",
                "year": "date",
            }
            break;
        case 4:
            return {
                "author": "authors",
                "note": "description",
                "number": "number",
                "institution": "institution",
                "organization": "institution",
                "publisher": "institution",
                "title": "statistics_title",
                "year": "date",
            }
            break;
        case 5:
            return {
                "author": "authors",
                "editor": "editors",
                "journal": "journal_name",
                "note": "contents",
                "institution": "institution",
                "organization": "institution",
                "publisher": "institution",
                "title": "issue_title",
                "volume": "volume",
                "number": "number",
                "year": "date",
            }
            break;
        case 6:
            return {
                "address": "place",
                "author": "authors",
                "editor": "editors",
                "series": "conference_name",
                "note": "contents",
                "number": "numberth",
                "institution": "institution",
                "organization": "institution",
                "publisher": "institution",
                "title": "issue_title",
                "year": "date",
            }
            break;
        case 7:
            return {
                "author": "authors",
                "journal": "newspaper_name",
                "note": "description",
                "number": "number",
                "institution": "company",
                "organization": "company",
                "publisher": "company",
                "title": "article_title",
                "year": "date",
            }
            break;
        case 8:
            return {
                "author": "authors",
                "booktitle": "magazine_title",
                "editor": "editors",
                "journal": "magazine_title",
                "note": "contents",
                "number": "number",
                "publisher": "publisher",
                "title": "issue_title",
                "year": "date",
            }
            break;
        case 9:
            return {
                "author": "creators",
                "booktitle": "album_name",
                "note": "contents",
                "institution": "label",
                "organization": "label",
                "publisher": "label",
                "title": "album_name",
                "year": "date",
            }
            break;
        case 10:
            return {
                "author": "directors",
                "note": "description",
                "institution": "production",
                "organization": "production",
                "publisher": "production",
                "title": "film_title",
                "year": "date",
            }
            break;
        case 100:
            return {
                "author": "authors",
                "booktitle": "book_title",
                "chapter": "chapter_title",
                "edition": "edition",
                "editor": "editors",
                "note": "description",
                "pages": "pages",
                "publisher": "publisher",
                "title": "chapter_title",
                "volume": "volume",
                "number": "number",
                "year": "date",
            }
            break;
        case 101:
            return {
                "author": "authors",
                "chapter": "chapter_title",
                "note": "description",
                "pages": "pages",
                "school": "university",
                "title": "title",
                "year": "date",
            }
            break;
        case 102:
            return {
                "author": "authors",
                "booktitle": "document_title",
                "chapter": "article_title",
                "editor": "editors",
                "note": "description",
                "number": "number",
                "institution": "institution",
                "organization": "institution",
                "pages": "pages",
                "publisher": "institution",
                "title": "article_title",
                "year": "date",
            }
            break;
        case 103:
            return {
                "author": "authors",
                "note": "description",
                "number": "number",
                "institution": "institution",
                "organization": "institution",
                "publisher": "institution",
                "title": "article_title",
                "year": "date",
            }
            break;
        case 104:
            return {
                "author": "authors",
                "note": "description",
                "number": "number",
                "institution": "institution",
                "organization": "institution",
                "publisher": "institution",
                "title": "table_title",
                "year": "statistics_date",
            }
            break;
        case 105:
            return {
                "author": "authors",
                "editor": "editors",
                "journal": "journal_name",
                "note": "abstract",
                "pages": "pages",
                "publisher": "institution",
                "title": "article_title",
                "volume": "volume",
                "number": "number",
                "year": "date",
            }
            break;
        case 106:
            return {
                "address": "place",
                "author": "authors",
                "series": "conference_name",
                "editor": "editors",
                "note": "abstract",
                "number": "numberth",
                "pages": "pages",
                "institution": "institution",
                "organization": "institution",
                "publisher": "institution",
                "title": "article_title",
                "year": "address_date",
            }
            break;
        case 107:
            return {
                "author": "reporters",
                "note": "description",
                "number": "number",
                "institution": "company",
                "organization": "company",
                "publisher": "company",
                "title": "article_title",
                "year": "date",
            }
            break;
        case 108:
            return {
                "author": "authors",
                "booktitle": "magazine_name",
                "editor": "editors",
                "note": "description",
                "number": "number",
                "pages": "pages",
                "publisher": "publisher",
                "title": "article_title",
                "volume": "volume",
                "year": "date",
            }
            break;
        case 109:
            return {
                "author": "creators",
                "note": "description",
                "institution": "label",
                "organization": "label",
                "publisher": "label",
                "title": "music_title",
                "year": "date",
            }
            break;
        case 110:
            return {
                "author": "directors",
                "note": "directors",
                "number": "episode_number",
                "institution": "production",
                "organization": "production",
                "publisher": "production",
                "title": "episode_title",
                "year": "date",
            }
            break;
        case 901:
            return {
                "author": "makers",
                "booktitle": "map_title",
                "note": "description",
                "institution": "publisher",
                "organization": "publisher",
                "publisher": "publisher",
                "title": "sub_title",
                "year": "date",
            }
            break;
        default:
            return {
                "author": "authors",
                "booktitle": "publication_title",
                "chapter": "sub_title",
                "edition": "edition",
                "editor": "editors",
                "journal": "publication_title",
                "note": "description",
                "number": "number",
                "organization": "publisher",
                "pages": "pages",
                "publisher": "publisher",
                "school": "publisher",
                "title": "sub_title",
                "volume": "number",
                "year": "date",
            }
    }
}

export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}


// WEBPACK FOOTER //
// ./src/custom/function.js